import { i18n } from '@/plugins/i18n';
import store from '@/store';
import { authHelper } from '@homeserve/vue-auth-plugin';
import { default as Axios } from 'axios';

const instance = Axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

instance.interceptors.request.use(config => {
  const userToken = authHelper.getUserToken(store);

  config.headers['Accept-Language'] = i18n.locale;

  if (authHelper.isUserAuthenticated(store) && userToken) {
    config.headers.Authorization = `Bearer ${userToken}`;
  }

  return config;
}, Promise.reject);

export { instance as HttpClient };
